import { Field, useFormikContext } from 'formik'
import React from 'react'
import { useLocation } from 'react-router-dom'

import { TinyMCE } from '@components/adapters/inputs/TinyMCE'
import { DashboardPermissionGuard } from '@components/utils/DashboardPermissions'
import { ButtonClean, Fieldset, Input, Subsection } from '@fourthwall/components'
import { reverse, routing } from '@utils/routing'

import type { ProductFormState } from '../../SingleProduct.types'
import { ProductCategory } from './modules/ProductCategory'
import * as S from './styled'

type ProductDetailsProps = {
  productId: string
  isFormEditable: boolean
  showCategories: boolean
}

export const ProductDetails = ({
  productId,
  isFormEditable,
  showCategories,
}: ProductDetailsProps) => {
  const location = useLocation()
  const { initialValues } = useFormikContext<ProductFormState>()

  return (
    <Subsection title="Product details">
      <Fieldset>
        <Fieldset.Row>
          <Fieldset.Item>
            <Field
              name="name"
              component={Input}
              label="Product name"
              disabled={!isFormEditable}
              fluid
            />
          </Fieldset.Item>
        </Fieldset.Row>
        <Fieldset.Row>
          <Fieldset.Item>
            <Field
              // NOTE: we need to reset TinyMCE touched state after each form reset to prevent initial value encoding
              name="description"
              component={TinyMCE}
              placeholder="Description (optional)"
              initialValue={initialValues.description}
              buttons={{ code: true }}
              disabled={!isFormEditable}
              resize
            />
          </Fieldset.Item>
        </Fieldset.Row>

        {showCategories && (
          <Fieldset.Row>
            <Fieldset.Item>
              <ProductCategory disabled={!isFormEditable} />
            </Fieldset.Item>
          </Fieldset.Row>
        )}

        <DashboardPermissionGuard permission="products.edit.additionalSections">
          <S.Buttons>
            <S.ButtonContainer>
              <ButtonClean
                label="Edit additional sections"
                to={{
                  pathname: reverse(routing.products.all.product.sections, { productId }),
                  search: location.search,
                }}
              />
            </S.ButtonContainer>
          </S.Buttons>
        </DashboardPermissionGuard>
      </Fieldset>
    </Subsection>
  )
}
